export default __webpack_public_path__ + "static/media/girl_with_laptop.aa7ef2a2.png";